import * as i0 from '@angular/core';
import { Directive, HostBinding, Input, NgModule } from '@angular/core';
import { IspuiInput, IspuiPassword, IspuiTextarea } from '@ispui/input/dist/components/index.js';

class ISPUIInputValueAccessor {
}
ISPUIInputValueAccessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIInputValueAccessor, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ISPUIInputValueAccessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: ISPUIInputValueAccessor, selector: "ispui-input:not([ngControl]),ispui-input:not([formControlName]),ispui-input[formControl],ispui-input:not([ngFormControl]),ispui-input:not([ngModel])", inputs: { label: "label", prefix: "prefix", invalid: "invalid", forceplaceholder: "forceplaceholder", clearbutton: "clearbutton", validationIcon: "validationIcon" }, host: { properties: { "attr.label": "this.label", "attr.prefix": "this.prefix", "attr.invalid": "this.invalid", "attr.forceplaceholder": "this.forceplaceholder", "attr.clearbutton": "this.clearbutton", "attr.validaton-icon": "this.validationIcon" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIInputValueAccessor, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ispui-input:not([ngControl]),ispui-input:not([formControlName]),ispui-input[formControl],ispui-input:not([ngFormControl]),ispui-input:not([ngModel])',
                }]
        }], propDecorators: { label: [{
                type: HostBinding,
                args: ['attr.label']
            }, {
                type: Input
            }], prefix: [{
                type: HostBinding,
                args: ['attr.prefix']
            }, {
                type: Input
            }], invalid: [{
                type: HostBinding,
                args: ['attr.invalid']
            }, {
                type: Input
            }], forceplaceholder: [{
                type: HostBinding,
                args: ['attr.forceplaceholder']
            }, {
                type: Input
            }], clearbutton: [{
                type: HostBinding,
                args: ['attr.clearbutton']
            }, {
                type: Input
            }], validationIcon: [{
                type: HostBinding,
                args: ['attr.validaton-icon']
            }, {
                type: Input
            }] } });

class ISPUIPasswordValueAccessor {
}
ISPUIPasswordValueAccessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIPasswordValueAccessor, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ISPUIPasswordValueAccessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: ISPUIPasswordValueAccessor, selector: "ispui-password:not([ngControl]),ispui-password:not([formControlName]),ispui-password[formControl],ispui-password:not([ngFormControl]),ispui-password:not([ngModel])", inputs: { label: "label", invalid: "invalid", eye: "eye", generate: "generate", generateLabel: "generateLabel", copy: "copy", copyLabel: "copyLabel", copySuccessMessage: "copySuccessMessage", isGeneratePassword: "isGeneratePassword", passwordGenLength: "passwordGenLength", chars: "chars", forceplaceholder: "forceplaceholder" }, host: { properties: { "attr.label": "this.label", "attr.invalid": "this.invalid", "attr.eye": "this.eye", "attr.generate": "this.generate", "attr.generate-label": "this.generateLabel", "attr.copy": "this.copy", "attr.copy-label": "this.copyLabel", "attr.copy-success-message": "this.copySuccessMessage", "attr.is-generate-password": "this.isGeneratePassword", "attr.password-gen-length": "this.passwordGenLength", "attr.chars": "this.chars", "attr.forceplaceholder": "this.forceplaceholder" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIPasswordValueAccessor, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ispui-password:not([ngControl]),ispui-password:not([formControlName]),ispui-password[formControl],ispui-password:not([ngFormControl]),ispui-password:not([ngModel])',
                }]
        }], propDecorators: { label: [{
                type: HostBinding,
                args: ['attr.label']
            }, {
                type: Input
            }], invalid: [{
                type: HostBinding,
                args: ['attr.invalid']
            }, {
                type: Input
            }], eye: [{
                type: HostBinding,
                args: ['attr.eye']
            }, {
                type: Input
            }], generate: [{
                type: HostBinding,
                args: ['attr.generate']
            }, {
                type: Input
            }], generateLabel: [{
                type: HostBinding,
                args: ['attr.generate-label']
            }, {
                type: Input
            }], copy: [{
                type: HostBinding,
                args: ['attr.copy']
            }, {
                type: Input
            }], copyLabel: [{
                type: HostBinding,
                args: ['attr.copy-label']
            }, {
                type: Input
            }], copySuccessMessage: [{
                type: HostBinding,
                args: ['attr.copy-success-message']
            }, {
                type: Input
            }], isGeneratePassword: [{
                type: HostBinding,
                args: ['attr.is-generate-password']
            }, {
                type: Input
            }], passwordGenLength: [{
                type: HostBinding,
                args: ['attr.password-gen-length']
            }, {
                type: Input
            }], chars: [{
                type: HostBinding,
                args: ['attr.chars']
            }, {
                type: Input
            }], forceplaceholder: [{
                type: HostBinding,
                args: ['attr.forceplaceholder']
            }, {
                type: Input
            }] } });

class ISPUITextareaValueAccessor {
}
ISPUITextareaValueAccessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUITextareaValueAccessor, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ISPUITextareaValueAccessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: ISPUITextareaValueAccessor, selector: "ispui-textarea:not([ngControl]),ispui-textarea:not([formControlName]),ispui-textarea[formControl],ispui-textarea:not([ngFormControl]),ispui-textarea:not([ngModel])", inputs: { label: "label", invalid: "invalid", forceplaceholder: "forceplaceholder" }, host: { properties: { "attr.label": "this.label", "attr.invalid": "this.invalid", "attr.forceplaceholder": "this.forceplaceholder" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUITextareaValueAccessor, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ispui-textarea:not([ngControl]),ispui-textarea:not([formControlName]),ispui-textarea[formControl],ispui-textarea:not([ngFormControl]),ispui-textarea:not([ngModel])',
                }]
        }], propDecorators: { label: [{
                type: HostBinding,
                args: ['attr.label']
            }, {
                type: Input
            }], invalid: [{
                type: HostBinding,
                args: ['attr.invalid']
            }, {
                type: Input
            }], forceplaceholder: [{
                type: HostBinding,
                args: ['attr.forceplaceholder']
            }, {
                type: Input
            }] } });

class ISPUIInputModule {
    constructor() {
        if (typeof customElements !== 'undefined') {
            [IspuiInput, IspuiPassword, IspuiTextarea].forEach((comp) => {
                if (!customElements.get(comp.is)) {
                    customElements.define(comp.is, comp);
                }
            });
        }
    }
}
ISPUIInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ISPUIInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIInputModule, declarations: [ISPUIInputValueAccessor, ISPUITextareaValueAccessor, ISPUIPasswordValueAccessor], exports: [ISPUIInputValueAccessor, ISPUITextareaValueAccessor, ISPUIPasswordValueAccessor] });
ISPUIInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIInputModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUIInputModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ISPUIInputValueAccessor, ISPUITextareaValueAccessor, ISPUIPasswordValueAccessor],
                    exports: [ISPUIInputValueAccessor, ISPUITextareaValueAccessor, ISPUIPasswordValueAccessor],
                }]
        }], ctorParameters: function () { return []; } });

/**
 * Generated bundle index. Do not edit.
 */

export { ISPUIInputModule, ISPUIInputValueAccessor, ISPUIPasswordValueAccessor, ISPUITextareaValueAccessor };
